import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  tr: {
    translation: {
      app: {
        title: 'Bakım Sistemi'
      },
      nav: {
        dashboard: 'Gösterge Paneli',
        qrScanner: 'QR Tarayıcı',
        maintenanceTasks: 'Bakım Görevleri',
        workOrders: 'İş Emirleri',
        elevators: 'Asansörler',
        customers: 'Müşteriler',
        inventory: 'Envanter',
        invoices: 'Faturalar',
        reports: 'Raporlar',
        users: 'Kullanıcılar',
        chat: 'Sohbet',
        notificationTest: 'Bildirim Testi',
        logout: 'Çıkış',
        openMenu: 'Menüyü aç',
        closeMenu: 'Menüyü kapat',
        categories: {
          operations: 'Operasyonlar',
          aiSystems: 'AI & Akıllı Sistemler',
          management: 'Yönetim',
          finance: 'Finans & Envanter',
          reportsComm: 'Raporlar & İletişim'
        }
      },
      lang: {
        label: 'Dil',
        tr: 'Türkçe',
        en: 'İngilizce',
        ru: 'Rusça'
      },
      qr: {
        title: 'QR Kod Tarayıcı',
        start: 'Kamera ile Tara',
        stop: 'Taramayı Durdur',
        frameHint: 'QR kodu kamera çerçevesi içine yerleştirin',
        accessTitle: 'Kamera Erişimi',
        manualTitle: 'QR Kod Girişi',
        send: 'Gönder',
        scanned: 'QR Kod Tarandı:'
      },
      customer: {
        newTitle: 'Yeni Müşteri',
        name: 'Ad',
        tax: 'Vergi No',
        address: 'Adres',
        contact: 'İletişim Kişisi',
        phone: 'Telefon',
        email: 'E-posta',
        contractType: 'Sözleşme Türü',
        premium: 'Premium',
        standard: 'Standart',
        basic: 'Temel',
        save: 'Kaydet',
        cancel: 'İptal',
        listTitle: 'Müşteriler',
        newButton: 'Yeni Müşteri'
      },
      elevator: {
        newTitle: 'Yeni Asansör',
        site: 'Site',
        code: 'Asansör Kodu',
        manufacturer: 'Üretici',
        model: 'Model',
        serial: 'Seri No (opsiyonel)',
        installationDate: 'Kurulum Tarihi (opsiyonel)',
        save: 'Kaydet',
        cancel: 'İptal'
      }
    }
  },
  en: {
    translation: {
      app: { title: 'Maintenance System' },
      nav: {
        dashboard: 'Dashboard', qrScanner: 'QR Scanner', maintenanceTasks: 'Maintenance Tasks', workOrders: 'Work Orders', elevators: 'Elevators', customers: 'Customers', inventory: 'Inventory', invoices: 'Invoices', reports: 'Reports', users: 'Users', chat: 'Chat', notificationTest: 'Notification Test', logout: 'Logout', openMenu: 'Open menu', closeMenu: 'Close menu'
      },
      lang: { label: 'Language', tr: 'Turkish', en: 'English', ru: 'Russian' },
      qr: { title: 'QR Scanner', start: 'Start Camera', stop: 'Stop Scanning', frameHint: 'Place the QR code inside the frame', accessTitle: 'Camera Access', manualTitle: 'QR Input', send: 'Send', scanned: 'Scanned QR:' },
      customer: { newTitle: 'New Customer', name: 'Name', tax: 'Tax No', address: 'Address', contact: 'Contact Person', phone: 'Phone', email: 'Email', contractType: 'Contract Type', premium: 'Premium', standard: 'Standard', basic: 'Basic', save: 'Save', cancel: 'Cancel', listTitle: 'Customers', newButton: 'New Customer' },
      elevator: { newTitle: 'New Elevator', site: 'Site', code: 'Elevator Code', manufacturer: 'Manufacturer', model: 'Model', serial: 'Serial (optional)', installationDate: 'Installation Date (optional)', save: 'Save', cancel: 'Cancel' }
    }
  },
  ru: {
    translation: {
      app: { title: 'Система обслуживания' },
      nav: {
        dashboard: 'Панель', qrScanner: 'Сканер QR', maintenanceTasks: 'Задачи ТО', workOrders: 'Наряд-заказы', elevators: 'Лифты', customers: 'Клиенты', inventory: 'Склад', invoices: 'Счета', reports: 'Отчеты', users: 'Пользователи', chat: 'Чат', notificationTest: 'Тест уведомлений', logout: 'Выход', openMenu: 'Открыть меню', closeMenu: 'Закрыть меню'
      },
      lang: { label: 'Язык', tr: 'Турецкий', en: 'Английский', ru: 'Русский' },
      qr: { title: 'Сканер QR', start: 'Включить камеру', stop: 'Остановить', frameHint: 'Поместите QR-код в рамку', accessTitle: 'Доступ к камере', manualTitle: 'Ввод QR', send: 'Отправить', scanned: 'Сканировано:' },
      customer: { newTitle: 'Новый клиент', name: 'Название', tax: 'ИНН', address: 'Адрес', contact: 'Контактное лицо', phone: 'Телефон', email: 'Email', contractType: 'Тип договора', premium: 'Премиум', standard: 'Стандарт', basic: 'Базовый', save: 'Сохранить', cancel: 'Отмена', listTitle: 'Клиенты', newButton: 'Новый клиент' },
      elevator: { newTitle: 'Новый лифт', site: 'Объект', code: 'Код лифта', manufacturer: 'Производитель', model: 'Модель', serial: 'Серийный (необ.)', installationDate: 'Дата установки (необ.)', save: 'Сохранить', cancel: 'Отмена' }
    }
  }
};

const savedLang = typeof window !== 'undefined' ? localStorage.getItem('lang') : null;

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLang || 'tr',
    fallbackLng: 'tr',
    interpolation: { escapeValue: false }
  });

export default i18n;


